import { render, staticRenderFns } from "./workRecords.vue?vue&type=template&id=33a582c6&scoped=true&"
import script from "./workRecords.vue?vue&type=script&lang=js&"
export * from "./workRecords.vue?vue&type=script&lang=js&"
import style0 from "./workRecords.vue?vue&type=style&index=0&id=33a582c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a582c6",
  null
  
)

export default component.exports